/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Cmp_Print_WebInputs */

const en_pc_online_cmp_print_web = /** @type {(inputs: Pc_Online_Cmp_Print_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloads the PDF for you to print`)
};

const zh_pc_online_cmp_print_web = /** @type {(inputs: Pc_Online_Cmp_Print_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载 PDF 后自行打印`)
};

/**
* | output |
* | --- |
* | "Downloads the PDF for you to print" |
*
* @param {Pc_Online_Cmp_Print_WebInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_cmp_print_web = /** @type {((inputs?: Pc_Online_Cmp_Print_WebInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Cmp_Print_WebInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_cmp_print_web(inputs)
	return zh_pc_online_cmp_print_web(inputs)
});
export { pc_online_cmp_print_web as "pc.online.cmp.print.web" }